import '../css/checkboxCustom.css';
import React from 'react';
import IcCheckBox from 'assets/svg/ic_check_box_circle.svg';
import IcCheckBoxSelect from 'assets/svg/ic_check_box_circle_select.svg';

const CheckBox = (props) => {
    const { listOption, setListOption, item, styles, icon, typeCheck } = props;
    return (
        <div id="checkbox-cus-container">
            <div className={`checkbox-container ${styles}`}>
                {
                    listOption ? (
                        <div onClick={() => setListOption(!listOption, item?.name)}>
                            {typeCheck ? <SVGCheckboxSelect /> : <SVGSelect />}
                        </div>
                    ) : (
                        // <img onClick={() => setListOption(!listOption, item?.name)} src={typeCheck ? IcCheckBox : 'assets/icon/Checkbox/Checked.svg'} alt="UnChecked" />
                        <div onClick={() => setListOption(!listOption, item?.name)}>
                            {typeCheck ? <SVGCheckbox /> : <SVGUnSelect />}
                        </div>
                    )
                }
                {icon && <div style={{ marginLeft: 8 }}>
                    {icon}</div>}
                <div className="checkbox-label">{item?.name}</div>
            </div>
        </div>
    );
};
export default CheckBox;


const SVGCheckboxSelect = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="9.99976" r="4" fill="#B98868" />
            <rect x="0.5" y="0.499756" width="19" height="19" rx="9.5" stroke="#B98868" />
        </svg>

    );
};

const SVGCheckbox = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.499756" width="19" height="19" rx="9.5" fill="white" />
            <rect x="0.5" y="0.499756" width="19" height="19" rx="9.5" stroke="#CBCBCD" />
        </svg>
    );
};


const SVGUnSelect = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="17" height="17" rx="4.5" fill="white" />
            <rect x="0.5" y="0.5" width="17" height="17" rx="4.5" stroke="#CBCBCD" />
        </svg>

    );
};

const SVGSelect = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="17" height="17" rx="4.5" fill="#FBF3EF" />
            <rect x="0.5" y="0.5" width="17" height="17" rx="4.5" stroke="#B98868" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14.1838 5.56624C14.3889 5.77127 14.3889 6.10368 14.1838 6.30871L8.05883 12.4337C7.8538 12.6387 7.52139 12.6387 7.31637 12.4337L4.25387 9.37121C4.04884 9.16618 4.04884 8.83377 4.25387 8.62874C4.45889 8.42372 4.7913 8.42372 4.99633 8.62874L7.6876 11.32L13.4414 5.56624C13.6464 5.36122 13.9788 5.36122 14.1838 5.56624Z" fill="#B98868" />
        </svg>
    );
};
